// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';

export default {
    async fetchGetTree(ctx) {
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            console.log('Отправка GET запроса на /api/v1/tree-nodes');
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tree-nodes`, config);
            console.log('Получены данные дерева:', response.data);
            
            // Обновляем список дерева
            ctx.commit('updateTreeList', response.data);
            
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении дерева:', error);
            throw error;
        }
    },
    
    async fetchGetTreeByDevice(ctx, payload) {
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            console.log(`Запрос дерева для устройства ${payload.id}`);
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tree-nodes/device/${payload.id}`, config);
            console.log('Получены данные дерева для устройства:', response.data);
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении дерева по устройству:', error);
            throw error;
        }
    },

    async fetchGetTreeInChildren(ctx, payload) {
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            console.log(`Запрос дочерних элементов для узла ${payload.id}`);
            // Получаем дочерние элементы для указанного родителя
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tree-nodes/${payload.id}`, config);
            console.log(`Получены данные для узла ${payload.id}:`, response.data);
            
            // API возвращает объект с полем children, а не массив дочерних элементов
            // Проверим формат ответа и правильно извлечем дочерние элементы
            let childNodes = [];
            
            if (response.data && response.data.children && Array.isArray(response.data.children)) {
                // Если сервер вернул объект с полем children
                childNodes = response.data.children;
                console.log(`Найдены дочерние элементы (${childNodes.length}) в поле children`);
            } else if (response.data && Array.isArray(response.data)) {
                // Если сервер вернул массив напрямую
                childNodes = response.data;
                console.log(`Найдены дочерние элементы (${childNodes.length}) в виде массива`);
            } else {
                console.warn('Неизвестный формат ответа API для дочерних элементов:', response.data);
            }
            
            if (childNodes.length > 0) {
                // Объединяем с существующими узлами
                const existingNodes = ctx.state.treeList || [];
                const newNodes = [...existingNodes];
                let updated = false;
                
                // Добавляем только те узлы, которых еще нет в списке
                childNodes.forEach(node => {
                    if (!newNodes.some(n => n.id === node.id)) {
                        newNodes.push(node);
                        updated = true;
                    }
                });
                
                // Обновляем список дерева, если были добавлены новые узлы
                if (updated) {
                    console.log('Обновляем список узлов с новыми дочерними элементами');
                    ctx.commit('updateTreeList', newNodes);
                }
            }
            
            return childNodes;
        } catch (error) {
            console.error('Ошибка при получении дочерних элементов:', error);
            throw error;
        }
    },

    async fetchDeleteNodeTree(ctx, payload) {
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            },
            data: {
                user_id: parseInt(localStorage.getItem('userId'))
            }
        };
        try {
            console.log(`Удаление узла ${payload.id}`);
            const response = await axios.delete(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tree-nodes/${payload.id}`, config);
            console.log(`Узел ${payload.id} удален`);
            
            // Обновляем состояние, удаляя узел из списка
            ctx.commit('removeNode', payload.id);
            
            return response.data;
        } catch (error) {
            console.error('Ошибка при удалении узла:', error);
            throw error;
        }
    },

    async fetchAddNodeTree(ctx, payload) {
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        
        // Формируем данные для отправки в API
        const nodeData = {
            name: payload.name,
            parent_id: payload.parent_id,
            device_id: payload.device_id || null,
            position: payload.position || 0
        };
        
        console.log('Данные для создания узла:', nodeData);
        
        try {
            console.log('Отправка POST запроса на /api/v1/tree-nodes');
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tree-nodes`, nodeData, config);
            console.log('Узел создан:', response.data);
            
            // Добавляем новый узел в список
            if (response.data && response.data.id) {
                ctx.commit('addNode', response.data);
                
                // Если у узла есть родитель, обновляем список дочерних элементов
                if (response.data.parent_id) {
                    await ctx.dispatch('fetchGetTreeInChildren', { id: response.data.parent_id });
                }
            }
            
            return response.data;
        } catch (error) {
            console.error('Ошибка при добавлении узла:', error);
            throw error;
        }
    },
    
    async fetchUpdateNodeTree(ctx, payload) {
        const access_token = ctx.rootGetters.access_token;
        
        // Формируем данные для обновления
        const updateData = {};
        
        if (payload.name !== undefined) {
            updateData.name = payload.name;
        }
        
        if (payload.parent_id !== undefined) {
            updateData.parent_id = payload.parent_id;
        }
        
        if (payload.device_id !== undefined) {
            updateData.device_id = payload.device_id;
        }
        
        if (payload.position !== undefined) {
            updateData.position = payload.position;
        }
        
        console.log(`Данные для обновления узла ${payload.id}:`, updateData);
        
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        
        try {
            console.log(`Отправка PUT запроса на /api/v1/tree-nodes/${payload.id}`);
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/tree-nodes/${payload.id}`,
                updateData,
                config
            );
            console.log(`Узел ${payload.id} обновлен`);
            
            // Обновляем узел в списке
            ctx.commit('updateNode', { id: payload.id, ...updateData });
            
            return response.data;
        } catch (error) {
            console.error('Ошибка при обновлении узла:', error);
            throw error;
        }
    }
};
